import { useCallback, useEffect, useState } from "react";
import { useFetchBillingCompany } from "@/components/hooks/useFetchBillingCompany";

/**
 * @summary Return if the user is ContractAdmin or not.
 * @param sub - the user's sub
 */
export function useAmIContractAdmin(): [boolean | null, (sub: string) => void] {
  const { companyResult, companyError, fetchCompany } =
    useFetchBillingCompany();
  const [amIContractAdmin, setAmIContractAdmin] = useState<boolean | null>(
    null
  );

  // 契約管理者であるか否かの判定
  const actionAmIContractAdmin = useCallback(
    async (sub: string) => {
      await fetchCompany();

      if (companyError) {
        throw new Error(`Error fetching company data: ${companyError}`);
      }

      // company query の fetch 完了後に実行する
      if (companyResult) {
        if (companyResult.company.admins) {
          if (
            companyResult.company.admins.find((admin) => admin.userSub === sub)
          ) {
            setAmIContractAdmin(true);
          } else {
            setAmIContractAdmin(false);
          }
        }
      }
    },
    [companyResult, companyError, fetchCompany]
  );

  // 初期化時には何もしない
  useEffect(() => {}, []);

  return [amIContractAdmin, actionAmIContractAdmin];
}

export function useAmIContractAdminNoCallback(): [
  boolean | null,
  (sub: string) => void
] {
  const [amIContractAdmin, setAmIContractAdmin] = useState<boolean | null>(
    null
  );

  const [sub, setSub] = useState<string>("");

  const { companyResult, companyError, fetchCompany } =
    useFetchBillingCompany();

  useEffect(() => {
    if (companyError) {
      throw new Error(`Error fetching company data: ${companyError}`);
    }

    if (companyResult) {
      if (companyResult.company.admins) {
        if (
          companyResult.company.admins.find((admin) => admin.userSub === sub)
        ) {
          setAmIContractAdmin(true);
        } else {
          setAmIContractAdmin(false);
        }
      }
    }
  }, [companyResult, companyError]);

  // 契約管理者であるか否かの判定;
  const actionAmIContractAdmin = (sub: string) => {
    setSub(sub);
    fetchCompany();
  };

  return [amIContractAdmin, actionAmIContractAdmin];
}
